import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index", //首页
    component: () => import("@/views/index/index-entry.vue"),
  },
  {
    path: "/list",
    name: "list", //列表
    component: () => import("@/views/index/list.vue"),
  },
  {
    path: "/detail",
    name: "detail", //详情
    component: () => import("@/views/index/detail.vue"),
  },
  {
    path: "/submit",
    name: "submit", //上传
    component: () => import("@/views/index/submit.vue"),
  },
  {
    path: "/agreement",
    name: "agreement", //详情
    component: () => import("@/views/agreement/index.vue"),
  },
  {
    path: "/history",
    name: "history", //历史
    component: () => import("@/views/index/history.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 返回上一级时，恢复之前的滚动位置
      return savedPosition;
    }
    // 期望滚动到哪个位置
    // return {
    //   x: 0,
    //   y: 0,
    // };
  },
});
// router.beforeEach((to, from, next) => {
// 	next();
// });
export default router;
